<template>
  <v-form :lazy="true" @submit.prevent>
    <h2>Lender Contact Information</h2>

    <label>Company Name</label>
    <v-text-field
      :value="product.title"
      @change="$emit('change', { field: 'title', value: $event })"
      label="Company Name"
      :rules="required"
      solo />

    <div class="email-group-wrapper">
      <div class="email-label-wrapper">
        <label>
          Email
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon size="14" v-on="on">mdi-information</v-icon>
            </template>

            <p class="tooltip-text">
              Add email addresses that you would like to have receive an email notification when a user matches with your loan product. “Primary” emails are displayed to users on your Lender Page.
            </p>
          </v-tooltip>
        </label>

        <button
          class="default-btn text link small"
          @click.prevent="addSecondaryEmail"
        >
          <v-icon class="pb-1">mdi-plus-circle-outline</v-icon>
          Add Email
        </button>
      </div>
      <div />

      <v-text-field
        :value="product.email"
        @change="$emit('change', { field: 'email', value: $event })"
        label="email@email.com" type="email"
        :rules="validateEmail"
        validate-on-blur
        hide-details
        solo />

      <button class="default-btn grey" disabled>
        Primary
      </button>

      <template v-for="(email, index) in product.emailsSecondary">
        <v-text-field
          :value="email"
          @change="$emit('change', { field: 'emailsSecondary', index, value: $event })"
          label="email@email.com" type="email"
          :rules="validateEmail"
          validate-on-blur
          hide-details
          solo
        />

        <v-menu :close-on-content-click="true" offset-y>
          <template #activator="{ on, value }">
            <button class="default-btn link" v-on="on">
              Actions
              <v-icon>{{ value ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </button>
          </template>

          <v-list>
            <v-list-item @click="setSecondaryEmailAsPrimary(index)">
              <v-list-item-title>Make Primary</v-list-item-title>
            </v-list-item>
            <v-list-item @click="removeSecondaryEmail(index)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>

    <label>Phone</label>
    <v-text-field
      label="(555)555-5555" type="tel"
      v-mask="phoneMask"
      v-model="product.phone"
      @input="$emit('change', { field: 'phone', value: $event })"
      :rules="validatePhone"
      solo />

    <label>Slogan</label>
    <v-text-field
      :value="product.slogan"
      @change="$emit('change', { field: 'slogan', value: $event })"
      label="Slogan"
      solo />

    <label>Company Description <span class="help">(600 characters max)</span></label>
    <v-textarea
      :value="product.description"
      @change="$emit('change', { field: 'description', value: $event })"
      counter="600"
      no-resize
      :rules="[
        ...required,
        v => !v || (v && v.length <= 600) || `Can only be ${600} maximum`,
      ]"
      solo />

    <label>
      Disclosure
      <v-tooltip bottom color="black">
        <template v-slot:activator="{ on }">
          <v-icon color="primary" v-on="on">mdi-information</v-icon>
        </template>
        <span>
          This is an optional field, you can enter a disclaimer or disclosure. It will appear at the bottom of your lender details page.
        </span>
      </v-tooltip>
    </label>
    <v-textarea
      :value="product.disclosure"
      @change="$emit('change', { field: 'disclosure', value: $event })"
      solo />

    <LogoInput
      :product="product"
      @change="$emit('change', $event)"
    />
  </v-form>
</template>

<script>
import { formMixin } from '@/mixins'

import LogoInput from './LogoInput'

export default {
  name: 'SectionInfo',
  mixins: [formMixin],
  components: {
    LogoInput,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    phoneMask: ['(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  }),

  methods: {
    addSecondaryEmail () {
      this.$emit('change', {
        field: 'emailsSecondary',
        value: [...(this.product.emailsSecondary || []).slice(0), ''],
      })
    },

    removeSecondaryEmail (index) {
      if (index >= (this.product.emailsSecondary || []).length) return
      this.$emit('change', {
        field: 'emailsSecondary',
        value: [...this.product.emailsSecondary.slice(0, index), ...this.product.emailsSecondary.slice(index + 1)],
      })
    },

    setSecondaryEmailAsPrimary (index) {
      if (index >= (this.product.emailsSecondary || []).length) return

      const primary = this.product.email
      const secondary = this.product.emailsSecondary[index]

      this.$emit('change', {
        field: 'email',
        value: secondary,
      })

      this.$emit('change', {
        field: 'emailsSecondary',
        value: [primary, ...this.product.emailsSecondary.slice(0, index), ...this.product.emailsSecondary.slice(index + 1)],
      })
    },
  },
}
</script>

<style lang="scss" scoped>
div.email-group-wrapper {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 5px;
  align-items: center;

  margin-bottom: 30px;

  .email-label-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    label {
      display: inline-block !important;
      margin-bottom: 0 !important;
    }
  }
}
</style>
